import React from 'react';
import { Box, Typography } from '@mui/material';
import { ChatBubbleOutlineOutlined } from '@mui/icons-material';

const DesktopPlaceholder = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      color: 'text.secondary',
      gap: 2,
    }}
  >
    <ChatBubbleOutlineOutlined sx={{ fontSize: 64, opacity: 0.3 }} />
    <Typography variant="body1" sx={{ opacity: 0.5 }}>
      Selecione uma conversa para começar
    </Typography>
  </Box>
);

export default DesktopPlaceholder;
